/**
 * Accessible labels for the results table's pagination control.
 *
 * The one survivor of `tableUtils.ts`, which otherwise held the hand-written
 * Workers Compensation column definitions the config-driven page replaced with
 * `buildColumnDefinitions`.
 */
export const PAGINATION_LABELS = {
  nextPageLabel: "Next page",
  pageLabel: (pageNumber: number) => `Go to page ${pageNumber}`,
  previousPageLabel: "Previous page",
};
